import React, { useEffect } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import { KB_EXTENSIONS } from "./KbEditor";
import "./KbEditor.css";

export default function KbViewer({ value }) {
  const editor = useEditor({ extensions: KB_EXTENSIONS, content: value || { type: "doc", content: [] }, editable: false });
  useEffect(() => {
    if (!editor) return;
    const next = value || { type: "doc", content: [] };
    if (JSON.stringify(editor.getJSON()) !== JSON.stringify(next)) editor.commands.setContent(next, false);
  }, [editor, value]);
  if (!editor) return null;
  return <div className="kbv2-content kbv2-viewer"><EditorContent editor={editor} /></div>;
}
